// this is an autogenerated file from App/Account/Content/Settings/Content/CommsEmail/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CommsEmail($email: String!, $name: String!) {
  insert_comms_outbound_emails_one(object: { email: $email, name: $name }) {
    id
  }
}

`